import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ITableDataSource } from '../interfaces/table/table-data-source.interface';
import { ITablePagination } from '../interfaces/table/table-pagination.interface';
import { ITableSort } from '../interfaces/table/table-sort.interface';

export class ApiService<T> {
  constructor(
    protected readonly httpClient: HttpClient,
    readonly host: string,
    readonly route: string,
    readonly baseUrl = `${host}${route}`,
  ) {}

  get<T = any>(additionalUrl = '', params?: any): Promise<T> {
    return lastValueFrom(this.httpClient.get<T>(`${this.baseUrl}${additionalUrl}`, { params }));
  }

  getPaginated(
    filters: any,
    sort?: ITableSort,
    pagination?: ITablePagination,
    suffixUrl = '',
  ): Promise<ITableDataSource<T>> {
    const tableOptions: any = {};

    if (filters) {
      tableOptions.filters = JSON.stringify(filters);
    }

    if (sort) {
      tableOptions.sort = JSON.stringify(sort);
    }

    if (pagination) {
      tableOptions.pagination = JSON.stringify(pagination);
    }

    return lastValueFrom(
      this.httpClient.get<ITableDataSource<T>>(`${this.baseUrl}${suffixUrl}`, {
        params: tableOptions,
      }),
    );
  }

  patch<T = any>(id?: number | string, body?: any, additionalUrl = ''): Promise<T> {
    if (id) {
      additionalUrl = `/${id}${additionalUrl}`;
    }
    return lastValueFrom(this.httpClient.patch<T>(`${this.baseUrl}${additionalUrl}`, body));
  }

  put<T = any>(additionalUrl = '', body?: any): Promise<T> {
    return lastValueFrom(this.httpClient.put<T>(`${this.baseUrl}${additionalUrl}`, body));
  }

  post<T = any>(body?: any, additionalUrl = ''): Promise<T> {
    return lastValueFrom(this.httpClient.post<T>(`${this.baseUrl}${additionalUrl}`, body));
  }

  delete<T = any>(body?: any, additionalUrl = ''): Promise<T> {
    return lastValueFrom(this.httpClient.delete<T>(`${this.baseUrl}${additionalUrl}`, { body }));
  }

  /** @deprecated Use {@link baseUrl} and append your string */
  async getRequestUrl(additionalUrl = ''): Promise<string> {
    return this.baseUrl + additionalUrl;
  }

  /** @deprecated Use {@link baseUrl}. */
  async getRouteUrl(): Promise<string> {
    return this.baseUrl;
  }
}
